import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/rolls/vannila rolls.png";
import BiscuitImg from "../../../assets/products/rolls/Vanilla-Roll.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 4,
  },
  {
    grams: 15,
  },
  {
    grams: 18,
  },
];

export default function VannilaRollProduct() {
  return (
    <>
      <Helmet>
        <title>Vanilla Roll – BearBitz | Premium Biscuits & Rolls</title>
        <meta
          name="description"
          content="Explore BearBitz Vanilla Rolls — crispy rolled wafers filled with creamy vanilla flavor. View pack sizes and specifications."
        />
        <meta name="keywords" content="Vanilla Roll, BearBitz Vanilla Roll" />
        <link rel="canonical" href="https://www.bearbitz.in/rolls/vannilaroll" />
        <meta property="og:title" content="Vanilla Roll – BearBitz" />
        <meta
          property="og:description"
          content="Crispy rolled wafer dessert filled with vanilla cream by BearBitz, export-ready and premium."
        />
      </Helmet>

      <ProductTemplate
        productTitle="VANILLA"
        productImage={BisImg}
        description="Crisp Layers, Creamy Delight Light, crunchy wafer layers filled with smooth cream in flavors like vanilla, chocolate, strawberry, and more. These biscuits offer a perfect bite of crisp and cream, making them a favorite among kids and teens. Easy to pack, easy to love – ideal for export markets worldwide."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#487BEF"
        sectionBgColor="#D7E3FF"
        productBgcolor="#739EFF"
        tableheadBgcolor="#487BEF"
        tableBgcolor="#F9FBFF"
        footerBgcolor="#487BEF"
      />
    </>
  );
}
